module.exports = __webpack_public_path__ + "static/media/paid_a.8333be55.svg";